import {
  SET_CHAIRMAN_MESSAGE,
  CHAIRMAN_LOADER,
  DOWNLOAD_COUNT,
} from "../actionTypes";

const initialState = {
  loader: false,
  chairmanMessage: {},
};

const chairmanReducer = (state = initialState, action) => {
  switch (action.type) {
    case CHAIRMAN_LOADER:
      return {
        ...state,
        loader: action.payload,
      };

    case SET_CHAIRMAN_MESSAGE:
      return {
        ...state,
        chairmanMessage: action.payload,
      };
    case DOWNLOAD_COUNT: {
      if (action.payload == "fileview") {
        return {
          ...state,
          chairmanMessage: {
            ...state.chairmanMessage,
            fileViewCount: (state.chairmanMessage?.fileViewCount || 0) + 1,
          },
        };
      } else
        return {
          ...state,
          chairmanMessage: {
            ...state.chairmanMessage,
            downloadCount: (state.chairmanMessage?.downloadCount || 0) + 1,
          },
        };
    }
    default:
      return state;
  }
};

export default chairmanReducer;
